import React from "react";
import type { CardProps } from "../Card/Card.web";
import Card from "../Card/Card.web";

type DetailCardContainerProps = {
  isModal?: boolean;
  children: React.ReactNode;
} & CardProps;

/**
 * Stylized card container used to wrap content sections
 * Adds padding, borderRadius, and backgroundColor to children
 * Currently used on the event and membership detail pages
 * @param isModal | boolean
 * @returns JSX.Element
 */
const DetailCardContainer: React.FC<DetailCardContainerProps> = ({
  isModal = false,
  children,
  ...props
}) => {
  return (
    <Card
      p="md"
      w="full"
      border="1px solid"
      borderColor={isModal ? "border" : "transparent"}
      rounded={{ base: isModal ? "lg" : 0, sm: "lg" }}
      color="fg"
      data-testid="card"
      {...props}
    >
      {children}
    </Card>
  );
};

export default DetailCardContainer;
